(function ($) {
  Drupal.behaviors.ehContentFormatter = {
    attach: function (context, settings) {
      var thisFormatter = $('.eh-content-formatter', context);

      thisFormatter.each(function () {
        var thisFormatter = $(this);
        var liItems = thisFormatter.find('.slides li');
        var max = Math.max.apply(Math, $.map(liItems, function () {
	  return $(this).height();
        }));

        liItems.height(max + 'px');
      });

      // IE 8, 9 specific fix.
      var msie = document.documentMode;
      if (msie === 8 || msie === 9) {
        thisFormatter.addClass('no-csstransforms3d');
      }
    }
  };
})(jQuery);
